import { ABAC } from '../primary-record-types';

export const fullAccessAppPermissions: ABAC.AppPermissions = {
    idsAndInfo: 'edit',
    medications: 'edit',
    conditions: 'edit',
    allergies: 'edit',
    careTeam: 'edit',
    visits: 'edit',
    patientPortals: 'edit',
    cloudCalendars: 'edit',
    settings: 'edit',
    reports: 'edit',
    files: 'edit',
    imaging: 'edit',
    procedures: 'edit',
    vaccinations: 'edit',
    labs: 'edit',
    collaborators: 'edit',
};

export const defaultInvitationDefinitionPermissions: ABAC.AppPermissions = {
    idsAndInfo: 'edit',
    medications: 'edit',
    conditions: 'edit',
    allergies: 'edit',
    careTeam: 'edit',
    visits: 'edit',
    patientPortals: 'edit',
    cloudCalendars: 'edit',
    settings: 'edit',
    reports: 'edit',
    files: 'edit',
    imaging: 'edit',
    procedures: 'edit',
    vaccinations: 'edit',
    labs: 'edit',
    collaborators: 'view',
};

export const noAccessAppPermissions: ABAC.AppPermissions = {
    idsAndInfo: 'denied',
    medications: 'denied',
    conditions: 'denied',
    allergies: 'denied',
    careTeam: 'denied',
    visits: 'denied',
    patientPortals: 'denied',
    cloudCalendars: 'denied',
    settings: 'denied',
    reports: 'denied',
    files: 'denied',
    imaging: 'denied',
    procedures: 'denied',
    vaccinations: 'denied',
    labs: 'denied',
    collaborators: 'denied',
};
